<script setup>
import { computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Loader from '@/components/Loader/Loader.vue';
import { isCurrentProfile, saveCurrentProfile } from '@/helpers/current-profile';
import { getItem } from '@/helpers/storage';
import { actionTypes } from '@/store/modules/profile/profiles';
import { PROFILES_GATE_REDIRECT_PATH } from '@/views/profiles/constants';

const store = useStore();
const router = useRouter();

const users = computed(() => store.state.profiles.data);
const isLoading = computed(() => store.state.profiles.isLoading);

const handleChoiceProfile = (profileNumber) => {
  const selectedProfile = users.value.find((user) => user.profile_number === profileNumber);
  if (!selectedProfile) return;

  const targetPath = getItem('savedPath') || PROFILES_GATE_REDIRECT_PATH;
  const isProfileChanged = !isCurrentProfile(selectedProfile);

  saveCurrentProfile(selectedProfile);

  if (isProfileChanged) {
    window.location.assign(router.resolve(targetPath).href);
    return;
  }

  router.push(targetPath);
};

onMounted(() => {
  store.dispatch(actionTypes.getProfiles);
});
</script>

<template>
  <div class="profile-selector">
    <div class="profile-selector-link">
      <h1 class="headline">{{ $t(`${$route.path}.title`) }}</h1>
      <ul class="profiles">
        <Loader class="loading" v-if="isLoading" />
        <li class="profile" v-for="user in users" :key="user.name">
          <button @click="handleChoiceProfile(user.profile_number)" class="profile-link">
            <img class="profile-image" :alt="user.name" :src="user.avatar" />
            <span class="profile-name">{{ user.name }}</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'style';
</style>
